import { useAnalyticsConsent } from "../contexts/AnalyticsConsentContext";

function AnalyticsConsentBanner() {
  const {
    consent,
    isSettingsOpen,
    setAnalyticsConsent,
    closeAnalyticsSettings,
  } = useAnalyticsConsent();

  if (
    !isSettingsOpen &&
    consent !== "unknown"
  ) return null;

  const isUpdating = consent !== "unknown" && isSettingsOpen;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[120] flex justify-center px-3 pb-3 sm:px-5 sm:pb-5">
      <section
        aria-label="Analytics preferences"
        className="pointer-events-auto w-full max-w-2xl rounded-2xl border border-gray-200 bg-white/95 p-4 text-gray-800 shadow-[0_14px_50px_rgba(0,0,0,0.18)] backdrop-blur sm:p-5"
      >
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-5">
          <div className="min-w-0">
            <p className="text-sm font-bold text-gray-900">
              Help us improve LettuceTalk
            </p>
            <p className="mt-1 text-xs leading-5 text-gray-600">
              Allow anonymous usage analytics to help us understand what is useful. Your cards and conversations work either way.
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <button
              type="button"
              onClick={() => setAnalyticsConsent("denied")}
              className="min-h-10 rounded-full border border-gray-300 px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
            >
              No thanks
            </button>
            <button
              type="button"
              onClick={() => setAnalyticsConsent("granted")}
              className="min-h-10 rounded-full bg-green-700 px-4 py-2 text-sm font-bold text-white transition hover:bg-green-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
            >
              Allow analytics
            </button>
          </div>
        </div>
        {isUpdating ? (
          <button
            type="button"
            onClick={closeAnalyticsSettings}
            className="mt-2 text-xs font-semibold text-gray-500 underline underline-offset-2 hover:text-gray-800"
          >
            Keep current choice
          </button>
        ) : null}
      </section>
    </div>
  );
}

export default AnalyticsConsentBanner;
